// import {useState} from "react";
import Navigation from "./routes";
// import {PanelDataContext} from "./panel/context";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { QueryClient, QueryClientProvider } from "react-query";
// import {useSocket} from "./panel/hooks";

const App = () => {
  // const socket = useSocket();
  // console.log(socket.emit("managerData", ""));

  const queryClient = new QueryClient({
    defaultOptions: {
      queries: {
        refetchOnWindowFocus: false,
        // staleTime: 1000 * 60,
      },
    },
  });

  return (
    <QueryClientProvider client={queryClient}>
      {/* <PanelDataContext.Provider value={{panelData, setPanelData}}> */}
      <Navigation />
      <ToastContainer
        draggable
        closeOnClick
        pauseOnHover
        pauseOnFocusLoss
        rtl={true}
        theme="dark"
        position="top-right"
        autoClose={2000}
        newestOnTop={false}
        hideProgressBar={false}
      />
      {/* </PanelDataContext.Provider> */}
    </QueryClientProvider>
  );
};

export default App;
